import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";

import { BrowserRouter as Router } from "react-router-dom";
import CustomSnackbar from "./notification/NotificationStyle";
import { AppProvider } from "./config/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <SnackbarProvider
        maxSnack={8} // Wrap App with SnackbarProvider
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Customize position
        autoHideDuration={6000}
        Components={{
          success: CustomSnackbar,
          error: CustomSnackbar,
        }}
      >
        <Router>
          <App />
        </Router>
      </SnackbarProvider>
    </AppProvider>
  </React.StrictMode>
);
